export enum ApplyOnModel {
  ADULT = "adult",
  CHILD = "child",
  PERSON = "person",
  ROOM = "room",
}
